module.exports = __webpack_public_path__ + "static/media/jaydan_thumn.1c9e6399.jpg";